/** ECBO allowed only when attained age is strictly below this (years). */
export const ECBO_MAX_AGE_EXCLUSIVE = 45;

export function getEcboToggleDisabledReason({
  paymentTermType,
  age,
  premiumRefundEnabled,
  hasAddPlusRider,
}) {
  const parts = [];
  if (paymentTermType === "Limited Pay") {
    parts.push("Enhanced Coverage is available only with Regular Pay.");
  }
  const ageNum = age != null ? Number(age) : NaN;
  if (
    age == null ||
    Number.isNaN(ageNum) ||
    ageNum >= ECBO_MAX_AGE_EXCLUSIVE
  ) {
    parts.push(
      "Enhanced Coverage is available only when life assured age is below 45 years.",
    );
  }
  if (premiumRefundEnabled) {
    parts.push("Turn off Return of Premium to use Enhanced Coverage.");
  }
  if (hasAddPlusRider) {
    parts.push(
      "Remove Accidental Death and Disability Plus to use Enhanced Coverage.",
    );
  }
  return parts.length ? parts.join(" ") : null;
}
